import React from "react";
import Script from "next/script";
import { useIntl } from "react-intl";
import { AppContext } from "contexts/app";
import { post_captchaApply, post_captchaValidate } from "api/xt-app";
import { message } from "antd";
import { getHosts } from "utils/method";
import sessionStorage from "utils/sessionStorage";

const captcha = {};

export default React.forwardRef(function Geetest(props, ref) {
  const intl = useIntl();
  const [appState, appDispatch] = React.useContext(AppContext);

  const [state_func, setState_func] = React.useState();
  React.useEffect(() => {
    console.log("state_func change", state_func);
    console.log("props", props);
    if (!state_func || !state_func.func) return;
    const { func, data } = state_func;
    props[func] && props[func](data);
  }, [state_func]);

  const verify = () => {
    if (captcha.offline) return setState_func({ func: "onSuccess" });
    const puzzleValidateString = sessionStorage.get("puzzleValidateString");
    if (puzzleValidateString) {
      setState_func({ func: "onSuccess", data: puzzleValidateString });
      sessionStorage.remove("puzzleValidateString");
      return;
    }
    // if (captcha.instance && captcha.instance.verify) {
    //   return captcha.instance.verify();
    // }
    if (captcha.instance && captcha.instance.showCaptcha) {
      return captcha.instance.showCaptcha();
    }

    console.error("【gt not ready】%o", captcha.instance);
    //message.error(intl.formatMessage({ id: "register.geetestError" }));
  };
  const reset = () => {
    if (captcha.offline) return;
    if (captcha.instance && captcha.instance.reset)
      return captcha.instance.reset();
    console.error("【验证码重置失败】%o", captcha.instance);
  };
  const destroy = () => {
    if (captcha.offline) return;
    if (captcha.instance && captcha.instance.destroy) {
      captcha.instance.destroy();
      return props.onDestroy && props.onDestroy();
    }
    console.error("【验证码销毁失败】%o", captcha.instance);
  };

  React.useEffect(() => {
    captcha.instance = null;
    post_captchaApply({ params: { type: 2 } })
      .then((data) => {
        // const { code, sdkKey, enabled } = data;
        const { code, sdkKey, enabled } = data;
        if (!enabled) {
          captcha.offline = true;
          return setState_func({ func: "onOffline" });
        }
        captcha.offline = false;
        // window.captcha = captcha;
        /*
        const config = {
          api_server: process.env.NEXT_PUBLIC_host + "/geapi",
          https: process.env.NEXT_PUBLIC_protocol === "https:",
          gt: sdkKey, //验证 id，极验后台申请得到
          challenge: code, //验证流水号，服务端 SDK 向极验服务器申请得到
          offline: !enabled, //极验API服务器是否宕机
          new_captcha: true, //宕机情况下使用，表示验证是 3.0 还是 2.0，3.0 的 sdk 该字段为 true
          product: props.product || "bind",
          width: "100%",
          lang: (() => {
            const obj = {
              cn: "zh-cn",
              hk: "zh-hk",
            };
            const lang = appState.lang;
            return obj[lang] || lang;
          })(),
        };
         */

        const { host, protocol } = getHosts();
        const config = {
          captchaId: sdkKey, //验证 id，极验后台申请得到
          product: props.product || "bind",
          language: (() => {
            const obj = {
              cn: "zho",
              hk: "zho-hk",
              en: "eng",
              ja: "jpn",
              in: "ind",
              ru: "rus",
              es: "spa",
            };
            const lang = appState.lang;
            return obj[lang] || "eng";
          })(),
          protocol: protocol + "//",
          apiServers: [host + "/geapi/v4"],
        };
        console.log("geetest", config);

        try {
          require("./gt4");
          initGeetest4(config, (captchaObj) => {
            captcha.instance = captchaObj;
            console.log("【验证码初始化成功】%o", captchaObj);
            captchaObj.appendTo("#geetest"); //将验证按钮插入到宿主页面中captchaBox元素内
            // 这里可以调用验证实例 captchaObj 的实例方法
            captchaObj.onSuccess(() => {
              const result = captchaObj.getValidate();
              console.log("【验证码验证成功】", result);
              //result对象包含 geetest_challenge，geetest_validate，geetest_seccode
              // result && onSuccess && onSuccess(result);

              post_captchaValidate({
                params: {
                  data: JSON.stringify(result),
                  type: 2,
                },
              })
                .then((data) => {
                  console.log("【验证码服务端校验成功】%o", data);
                  // props.onSuccess && props.onSuccess(data.certificate);
                  setState_func({ func: "onSuccess", data: data.certificate });
                })
                .catch((e) => {
                  console.error("【验证码服务端校验失败】%o", e);
                  reset();
                });
            });
          });
        } catch (e) {
          console.warn("【验证码捕获错误】%o", e);
        }

        // if (enabled) this.initGeetest();
        // else this.$emit("offline");
      })
      .catch((e) => {
        message.error(intl.formatMessage({ id: "register.geetestError" }));
        console.error("【验证码初始化失败】%o", e);
      });
  }, []);

  React.useImperativeHandle(ref, () => ({ verify, reset, destroy }));

  return <div id={"geetest"} style={{ display: "none" }}></div>;
});
